
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 2a1.875 1.875 0 01.774 3.581V7.67c.028.005.057.008.084.014.854.17 1.639.59 2.254 1.205l-.802.802a3.266 3.266 0 100 4.62l.802.802a4.403 4.403 0 01-2.254 1.205c-.027.006-.056.008-.084.013v2.089A1.874 1.874 0 0111 22a1.875 1.875 0 01-.774-3.581V16.33a4.403 4.403 0 01-2.886-1.886 4.399 4.399 0 01-.67-1.67H4.58A1.874 1.874 0 011 12a1.875 1.875 0 013.581-.774H6.67a4.4 4.4 0 01.67-1.671 4.403 4.403 0 012.886-1.887V5.581A1.874 1.874 0 0111 2zm0 17.25A.875.875 0 1011 21a.875.875 0 000-1.75zm8.125-9.125a1.875 1.875 0 11-1.706 2.65h-4.713A1.874 1.874 0 019.125 12a1.875 1.875 0 013.581-.774h4.713c.295-.65.947-1.101 1.706-1.101zm-16.25 1a.875.875 0 100 1.75.875.875 0 000-1.75zm8.125 0a.875.875 0 100 1.75.875.875 0 000-1.75zm8.125 0a.875.875 0 100 1.75.875.875 0 000-1.75zM11 3a.875.875 0 100 1.75A.875.875 0 0011 3z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M22.47 16.47a.75.75 0 111.06 1.06l-5.5 5.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06l1.97 1.97 4.97-4.97z","fill":"#2ECC71"}})])
          )
        }
      }
    